/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionContext, Module } from 'vuex';
import { Toast } from '@hb/coffee';

import BioApi, { ocrUpload } from '@/api/bio';
import store from '@/store';
import type RootStateType from '@/store/types';
import generateMutations, {
  UPDATE_STATE_TYPE,
} from '@/store/generate-mutations';
import NativeApi from '@/api/native';
import { NativeOCRBack, NativeOCRFront, uploadFileOptionsTypeEnum } from '@/api/native/types';
import UploadImg from '@/api/uploadImg';
import { dayjs } from '@/shared/utils/day';
import platform from '@/shared/utils/platform';
import { alipayHitchTakePhoto, uploadFile } from '@/api/native/cardPhoto';
import { platformIdentityManager } from '@/shared/identity-verification';
import {
  UploadTypeEnum, UploadProcessTypeEnum, OCRDataSourceTypeEnum, OcrProcessSourceEnum,
  OcrOperationSourceEnum,
} from '@/shared/tools/ocr/enum';
import { getOcrMsgSource } from '@/shared/verify-credit-controller/utils';
import { ubtExposeNewOcr, TE_OCR_ENTER_MSG_SOURCE } from '@/shared/tools/ocr/tianqi';
import { session } from '@/shared/utils/storage';
import type { StateType } from './types';

// 小程序拍照
const alipayHitchTakePic = async (uploadType: UploadTypeEnum, onlyCamera: boolean) => {
  const alipayFilePath = await alipayHitchTakePhoto({
    count: 1,
    sourceType: [uploadType === UploadTypeEnum.Camera || onlyCamera ? 'camera' : 'album'],
    sizeType: ['compressed'],
  });
  if (alipayFilePath) {
    const alipayRomtePath = await uploadFile(
      alipayFilePath[0],
      {
        image: 75,
        type: uploadFileOptionsTypeEnum.MINIPRO_ALIPAY,
      },
    );
    return alipayRomtePath;
  }
};


// 拍照并返回照片base64内容
const captureIdentityPhoto = async (
  isFront: boolean,
  useCropRatio: boolean,
  cropRatio: number,
  uploadType: UploadTypeEnum,
  onlyCamera: boolean,
): Promise<string> => {
  // 哈啰App的Android版本在用户识别失败之后重新尝试拍照识别
  const _cropRatio = useCropRatio ? cropRatio : undefined;

  // 相册上传
  if (uploadType === UploadTypeEnum.Album && !onlyCamera) {
    const selectPhotos = await NativeApi.selectPhotos().catch(() => {
      throw new Error('APP没有开启相册权限!');
    });
    if (selectPhotos.length === 0) {
      return '';
    }
    const { path, width, height } = selectPhotos[0];
    const targetMaxSize = 500;
    let targetWidth = 0;
    let targetHeight = 0;
    // 等比例缩放
    if (width > targetMaxSize || height > targetMaxSize) {
      if (width > height) {
        targetWidth = targetMaxSize;
        targetHeight = Math.round(targetWidth * (height / width));
      } else {
        targetHeight = targetMaxSize;
        targetWidth = Math.round(targetHeight * (width / height));
      }
    }
    return NativeApi.getBase64ByPath(path, {
      mimeType: 1,
      quality: 1,
      width: targetWidth,
      height: targetHeight,
      crop: 0,
    }).then(({ imageBase64 }) => `data:image/png;base64,${imageBase64}`);
  }

  return (isFront
    ? NativeApi.takeFrontPhoto(_cropRatio)
    : NativeApi.takeBackPhoto(_cropRatio)
  )
    .then(({ photoStr }) => `data:image/png;base64,${photoStr}`)
    .catch(() => {
      throw new Error('APP没有开启身份证拍照权限!');
    });
};

// 上传照片到oss并返回图片链接
const uploadPhotoToOss = (
  photoStrBase64: string,
  isFront: boolean,
): Promise<string> => {
  if (isFront) {
    return BioApi.uploadFrontCard(photoStrBase64);
  }

  return BioApi.uploadBackCard(photoStrBase64);
};

// 识别照片中的ocr数据
const checkIdentityOcr = (
  photoUrl: string,
  isFront: boolean,
  uploadType: number,
  options?: Record<string, unknown>,
  processSource?: OcrProcessSourceEnum,
  operationSource?: OcrOperationSourceEnum,
) => BioApi.onlineOCR({
  pic: photoUrl,
  uploadType,
  processType: UploadProcessTypeEnum.CAMERA,
  front: isFront,
  processSource,
  operationSource,
}, options).catch((error) => {
  error.isCheckOcrError = true;
  throw error;
});

const toUnixTime = (time: string) => {
  if (String(time).length > 8) {
    return time;
  }
  return `${dayjs(String(time), 'YYYYMMDD').unix() * 1000}`;
};

// 根据照片类型返回对应的数据对象
const getIdentityProps = (params: {
  isFront: boolean;
  ossCardUrl?: string;
  photoStrBase64?: string;
  ocrInfo: NativeOCRFront | NativeOCRBack;
}) => {
  const {
    isFront, ossCardUrl, ocrInfo,
  } = params;
  const frontOcrInfo = ocrInfo as NativeOCRFront;
  const backOcrInfo = ocrInfo as NativeOCRBack;
  return isFront
    ? {
      idCardFrontUrl: ossCardUrl,
      idCardFrontImg: '',
      idCardFrontBase64: '', // base64 占内存，且后续流程用不到，不再保存
      idCardNo: frontOcrInfo.number,
      userAddress: frontOcrInfo.address,
      userBirth: frontOcrInfo.birth,
      userName: frontOcrInfo.name,
      userNation: frontOcrInfo.nationality,
      userSex: frontOcrInfo.sex,
      frontTransactionId: frontOcrInfo.frontTransactionId,
    }
    : {
      idCardBackUrl: ossCardUrl,
      idCardBackImg: '',
      idCardBackBase64: '',
      issues: backOcrInfo.authority,
      periodBegin: toUnixTime(backOcrInfo.startDate),
      periodEnd: toUnixTime(backOcrInfo.endDate),
      backTransactionId: backOcrInfo.backTransactionId,
    };
};

const getImgBase64 = (file: Blob): Promise<string> => new Promise((resolve, reject) => {
  try {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const base64 = fileReader.result as string;
      resolve(base64);
    };
    fileReader.readAsDataURL(file);
  } catch (error) {
    reject(error);
  }
});

const moduleStore: Module<StateType, RootStateType> = {
  namespaced: true,
  state: {
    // 身份证拍照模块
    frontIdCard: '',
    backIdCard: '',
    currentIdCard: '',
    ocrDataType: OCRDataSourceTypeEnum.MANUAL,
    identity: {
      idCardFrontImg: '',
      idCardFrontUrl: '',
      idCardFrontBase64: '',
      userAddress: '',
      userBirth: '',
      userName: '',
      userNation: '',
      userSex: '',
      idCardNo: '',
      idCardBackImg: '',
      idCardBackUrl: '',
      idCardBackBase64: '',
      issues: '',
      periodBegin: '',
      periodEnd: '',
      uploadType: 0,
      isTempUploadType: false,
    },
    defaultUserName: '',
    shouldMaskUserName: false,
    defaultIdCardNo: '',
    shouldMaskIdCardNo: false,
    cropRatio: 0.8,
    useCropRatioBackupPlan: false,
    isCropRatioSupported: false,
    isUseCropRatioTangramMatched: true,
    isFront: true,
  },
  getters: {
    // 身份证正面是否识别成功
    isFrontOcrSucc(state: StateType): boolean {
      const { identity } = state;

      return !!(
        identity
        && identity.idCardFrontUrl
        && identity.idCardNo
        && identity.userAddress
        && identity.userBirth
        && identity.userName
        && identity.userNation
        && identity.userSex
      );
    },

    hasFrontOcrData(state: StateType): boolean {
      const { identity } = state;

      // 用户姓名可能在编辑过程中为空
      return !!(
        identity
        && identity.idCardFrontUrl
        && identity.idCardNo
        && identity.userAddress
        && identity.userBirth
        && identity.userNation
        && identity.userSex
      );
    },

    // 身份证反面是否识别成功
    isBackOcrSucc(state: StateType): boolean {
      const { identity } = state;

      return !!(
        identity
        && identity.idCardBackUrl
        && identity.issues
        && identity.periodBegin
        && identity.periodEnd
      );
    },

    hasBackOcrData(state: StateType, getters: Dictionary<boolean>): boolean {
      return getters.isBackOcrSucc;
    },

    // 整体身份证正反面识别成功
    isOcrSucc(state: StateType, getters: Dictionary<boolean>): boolean {
      return !state.identity.isTempUploadType && getters.isFrontOcrSucc && getters.isBackOcrSucc;
    },

    // 身份证识别信息是否已经返回（和isOcrSucc的区别在用户可能会清空姓名）
    hasIdentityData(state: StateType, getters: Dictionary<boolean>): boolean {
      return getters.hasFrontOcrData || getters.hasBackOcrData || !!state.identity.idCardNo;
    },

    // 是否使用cropRatio属性
    useCropRatio(state: StateType): boolean {
      return (
        state.useCropRatioBackupPlan
        && state.isUseCropRatioTangramMatched
        && state.isCropRatioSupported
      );
    },

    // 评估cropRatio属性是否可以使用，主要用于埋点标记
    canUseCropRatio(state: StateType): boolean {
      return state.isUseCropRatioTangramMatched && state.isCropRatioSupported;
    },
  },
  actions: {
    // 获取用户身份证数据
    async getIdentity(
      context: ActionContext<StateType, RootStateType>,
      payload: {
        processSource: OcrProcessSourceEnum,
      },
    ): Promise<void> {
      try {
        const res = await BioApi.getIdentity(await platformIdentityManager.newUserAuthProgress(), payload?.processSource);
        const identity = platformIdentityManager.dispatchNewUserStatus ? (res.userInfo || {}) : res;
        const msgSource = getOcrMsgSource(identity);

        ubtExposeNewOcr(TE_OCR_ENTER_MSG_SOURCE, {
          msgSource,
          scene: payload?.processSource,
        });

        session.set('ocrMsgSource', msgSource);

        if (platformIdentityManager.dispatchNewUserStatus) {
          // OCR新流程中，会返回 ocrDataType
          const { ocrDataType } = res;
          context.dispatch(UPDATE_STATE_TYPE, { ocrDataType });
        } else {
          // OCR老流程中，不会返回 ocrDataType
          // 老流程中不会带出平台实名信息
          // 如果有身份证双面图片，则认为是金融带出
          context.dispatch(UPDATE_STATE_TYPE, {
            ocrDataType: identity.idCardFrontUrl && identity.idCardBackUrl
              ? OCRDataSourceTypeEnum.FINANCE
              : OCRDataSourceTypeEnum.MANUAL,
          });
        }

        /** 如果上一次是OCR自动识别上传的，在老的ocr改为拍摄 */
        if (identity.uploadType) {
          identity.uploadType = identity.uploadType === UploadTypeEnum.SDKCamera ? UploadTypeEnum.Camera : identity.uploadType;
        }

        // 1\用户已认证 身份证或者姓名有值
        // 2\且身份证照片有值（解决钉钉场景 有姓名和身份证号，但是没有照片的时候，把接口数据写入表达 并成功提交的问题）
        // 上述两个场景都满足时 去更新
        const { frontIdCard, backIdCard } = context.state;
        if ((identity.idCardNo && identity.idCardFrontUrl)
        || (identity.idCardNo && platformIdentityManager.dispatchNewUserStatus)) {
          context.dispatch(UPDATE_STATE_TYPE, {
            identity: {
              ...context.state.identity,
              ...identity,
              /** 因为uploadType变更，会触发changeUploadType函数，把isTempUploadType取反，
               * 如果isTempUploadType为true，当前上传方法显示图片为空。
               * 为避免该场景，uploadType改变，并且有正反面照片时，赋初值为true
               * 1. 首次进入跟默认值uploadType为0做对比
               * 2. 二次进入跟store里的uploadType做对比
               */
              isTempUploadType: (identity.idCardFrontUrl
                && identity.idCardBackUrl
                && identity.uploadType !== context.state.identity.uploadType)
                ? true
                : context.state.identity.isTempUploadType,
            },
            frontIdCard: identity.idCardFrontUrl || frontIdCard,
            backIdCard: identity.idCardBackUrl || backIdCard,
            defaultUserName: identity.userName || '',
            shouldMaskUserName: !!identity.userName,
            defaultIdCardNo: identity.idCardNo || '',
            shouldMaskIdCardNo: !!identity.idCardNo,
          });
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.resolve();
      }
    },

    // 获取照片采集尺寸系数
    async initCropRatioInTangram(
      context: ActionContext<StateType, RootStateType>,
    ): Promise<void> {
      try {
        context.dispatch(UPDATE_STATE_TYPE, {
          cropRatio: platform.isIOS ? 1.2 : 0.8,
          useCropRatioBackupPlan: false,
          isCropRatioSupported: NativeApi.isCropRatioSupportedInHitchTakePhotos(),
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.resolve();
      }
    },

    // 唤起身份证拍照
    async captureIdentity(
      context: ActionContext<StateType, RootStateType>,
      paramsData: {
        isFront: boolean,
        onlyCamera: boolean,
        e: { target: { files: any[]; value: any}; },
        checkOcrReqOptions?: Record<string, unknown>,
        processSource?: OcrProcessSourceEnum,
        operationSource?: OcrOperationSourceEnum,
      },
    ): Promise<void> {
      try {
        let ossCardUrl = '';
        let photoStrBase64 = '';
        let resizedPhoto = '';
        if (platform.isAlipayMini) {
          const alipayPathOssUrl = await alipayHitchTakePic(context.state.identity.uploadType, paramsData.onlyCamera);
          const fileUrl = alipayPathOssUrl?.data?.url;
          if (!fileUrl) {
            Toast('网络异常，请重试');
            return;
          }
          const params = {
            fileUrl,
            scene: paramsData.isFront ? 'user-id1' : 'user-id0',
          };
          ossCardUrl = await ocrUpload(params);
        } else if (platform.isHelloApp) {
          photoStrBase64 = await captureIdentityPhoto(
            paramsData.isFront,
            context.getters.useCropRatio,
            context.state.cropRatio,
            context.state.identity.uploadType,
            paramsData.onlyCamera,
          );
          if (!photoStrBase64) return;
          // 图片资源压缩
          resizedPhoto = await UploadImg.reSizeImg(photoStrBase64);
          // 设置当前拍照照片，在识别失败的时候展示给用看并辅助研发定位问题
          context.dispatch(UPDATE_STATE_TYPE, {
            currentIdCard: resizedPhoto,
          });
          ossCardUrl = await uploadPhotoToOss(resizedPhoto, paramsData.isFront);
        } else {
          // H5场景
          const file = paramsData.e.target.files[0];

          photoStrBase64 = await getImgBase64(file);
          paramsData.e.target.value = '';
          resizedPhoto = await UploadImg.reSizeImg(photoStrBase64);
          ossCardUrl = await uploadPhotoToOss(resizedPhoto, paramsData.isFront);
        }
        // eslint-disable-next-line no-console
        console.log(ossCardUrl, 'ossCardUrl');

        const ocrInfo = await checkIdentityOcr(
          ossCardUrl,
          paramsData.isFront,
          context.state.identity.uploadType,
          paramsData.checkOcrReqOptions,
          paramsData.processSource,
          paramsData.operationSource,
        );
        const {
          identity,
        } = context.state;
        const identityData = getIdentityProps({
          isFront: paramsData.isFront,
          ocrInfo,
          ossCardUrl,
          photoStrBase64,
        });
        const defaultFrontInfo = paramsData.isFront ? {
          defaultUserName: identityData.userName,
          shouldMaskUserName: !identityData.userName, // 拍照获取信息后，信息不脱敏展示
          defaultIdCardNo: identityData.idCardNo,
          shouldMaskIdCardNo: !identityData.idCardNo, // 拍照获取信息后，信息不脱敏展示
        } : {};
        context.dispatch(UPDATE_STATE_TYPE, {
          currentIdCard: '',
          identity: {
            ...identity,
            ...identityData,
          },
          [paramsData.isFront ? 'frontIdCard' : 'backIdCard']: ossCardUrl,
          ...defaultFrontInfo,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};

store.registerModule(
  'baseInfoIdentity',
  generateMutations<StateType>(moduleStore),
  {
    preserveState: !!store.state.baseInfoIdentity,
  },
);
